var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRoot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.09091 1V4.85H7.36364V6.775H3.54545C2.83909 6.775 2.27273 7.34608 2.27273 8.05833V11.15H1V15H4.81818V11.15H3.54545V8.05833H7.36364V11.15H6.09091V15H9.90909V11.15H8.63636V8.05833H12.4545V11.15H11.1818V15H15V11.15H13.7273V8.05833C13.7273 7.34608 13.1609 6.775 12.4545 6.775H8.63636V4.85H9.90909V1H6.09091Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoot);
export default __webpack_public_path__ + "static/media/icon-root.a80bd3d6b724325946c2af2c8df3506f.svg";
export { ForwardRef as ReactComponent };